import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { Grid, Button, Form } from 'semantic-ui-react'
import { ControlledCheckbox, ControlledInput } from './ControlledForm'

export const LoginForm = ({ site, onSubmit, username, allowRememberMe }: any) => {
  const { control, handleSubmit } = useFormContext();

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Form.Field required>
        <label htmlFor='email'>{username.label}</label>
        <ControlledInput name='email' placeholder={username.placeholder} control={control}/>
      </Form.Field>
      <Form.Field required>
        <label htmlFor='password'>Password</label>
        <ControlledInput type='password' name='password' placeholder='Password' control={control}/>
      </Form.Field>
      <Form.Field>
      { allowRememberMe && <ControlledCheckbox name='remember' label='Remember me'/> }
      </Form.Field>
      <Grid columns='equal' verticalAlign='middle' textAlign='center'>
        <Grid.Column>
          <Button type="submit" fluid primary size='large'>Sign In</Button>
        </Grid.Column>
        <Grid.Column>
          <Link to={`/${site}/forgot`}>Forgot Password</Link>
        </Grid.Column>
      </Grid>
    </Form>
  )
}

export default LoginForm
